import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { toggleQueuedPost, updatePublishAt, orgInitialState } from 'redux/modules/composeboxForm';
import { FormAccordionSection } from 'components';
import moment from 'moment';
import * as styles from './Composebox.scss';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import DatePicker from 'components/DatePicker/DatePicker';
var ScheduleArea = (_dec = connect(function (state) {
  var _state$schedule$posts;

  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    orgPosts: (_state$schedule$posts = state.schedule.posts) !== null && _state$schedule$posts !== void 0 && _state$schedule$posts[orgId] ? _toConsumableArray(state.schedule.posts[orgId]).filter(function (p) {
      return p.type !== 'AD';
    }) : [],
    selectedTimezone: state.organization.selectedOrgDetails[orgId].OrganizationTimezone,
    timezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    },
    loadingPosts: state.schedule.loadingPosts
  };
}, {
  toggleQueuedPost: toggleQueuedPost,
  updatePublishAt: updatePublishAt
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ScheduleArea, _Component);

  var _super = _createSuper(ScheduleArea);

  function ScheduleArea(props) {
    var _this;

    _classCallCheck(this, ScheduleArea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getAdjustedTime", function (timestring) {
      return moment.utc(timestring).add(_this.props.timezone.utc_offset.hours, 'hours').add(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "getUtcTime", function (timestring) {
      return moment.utc(timestring).subtract(_this.props.timezone.utc_offset.hours, 'hours').subtract(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;
      var newMoment = moment(_this.props.composeboxForm.publishAt);
      newMoment.date(incomingMoment.date());
      newMoment.month(incomingMoment.month());
      newMoment.year(incomingMoment.year());

      _this.props.updatePublishAt(newMoment.valueOf(), organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;

      _this.props.updatePublishAt(incomingMoment.valueOf(), organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleQueuedPost", function () {
      var organizationId = _this.props.organizationId;

      _this.props.toggleQueuedPost(organizationId);
    });

    _this.state = {
      displayedDate: moment(),
      showScheduleDialog: false,
      dialogSelectedDate: moment(_this.props.composeboxForm.publishAt)
    };
    return _this;
  }

  _createClass(ScheduleArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          composeboxForm = _this$props.composeboxForm,
          organizationId = _this$props.organizationId,
          loadingPosts = _this$props.loadingPosts;
      var publishAtMoment = this.getAdjustedTime(composeboxForm.publishAt);
      var formattedPostTime = /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("span", null, publishAtMoment.format('MMMM Do, YYYY')), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: 10
        }
      }, publishAtMoment.format('h:mm A')));
      var loadingPostsSpinner = /*#__PURE__*/React.createElement("div", null, loadingPosts && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin",
        style: {
          color: '#616161',
          fontSize: 36
        }
      })));
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, !!composeboxForm.existingPostQueueId && !composeboxForm.convertQueuedPost ? /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          paddingTop: 10
        }
      }, /*#__PURE__*/React.createElement("span", null, "This post is in your Queue. If you wish to schedule this post for a certain date and time, you can do so by clicking", ' ', /*#__PURE__*/React.createElement("span", {
        onClick: this.handleToggleQueuedPost,
        style: {
          cursor: 'pointer',
          textDecoration: 'underline'
        }
      }, "here"), "."))) : /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "publishAt",
        value: moment(composeboxForm.publishAt).format('M/D/YYYY , h:mm A'),
        onClick: function onClick() {
          return _this2.setState({
            showScheduleDialog: true
          });
        },
        floatingLabelFixed: true,
        floatingLabelText: "Scheduled Post Time",
        style: {
          marginLeft: 20,
          marginTop: -16
        }
      })), /*#__PURE__*/React.createElement(Dialog, {
        bodyStyle: {
          marginTop: 16
        },
        modal: true,
        title: "Pick A Post Time",
        autoScrollBodyContent: true,
        open: this.state.showScheduleDialog,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showScheduleDialog: false
          });
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          style: {
            marginRight: 24
          },
          label: "Cancel",
          onClick: function onClick() {
            _this2.setState({
              showScheduleDialog: false
            });
          }
        }), /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          label: "Set Post Time",
          disabled: !this.state.dialogSelectedDate || this.state.dialogSelectedDate && moment(this.state.dialogSelectedDate).isBefore(moment().subtract(15, 'minutes')),
          onClick: function onClick() {
            _this2.props.updatePublishAt(new Date(_this2.state.dialogSelectedDate).getTime().valueOf(), _this2.props.organization.id);

            _this2.setState({
              showScheduleDialog: false
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(DatePicker, {
        style: {
          width: '100%'
        },
        open: true,
        displayedDate: this.state.displayedDate,
        loadingPosts: loadingPostsSpinner,
        onRequestDecrementMonth: function onRequestDecrementMonth(currentDate) {
          var newDate = moment(currentDate).subtract(1, 'month');

          _this2.setState({
            displayedDate: newDate
          });

          _this2.props.loadPosts(_this2.props.organization.id, _this2.props.selectedTimezone, newDate.startOf('month').toDate(), newDate.endOf('month').toDate(), false);
        },
        onRequestIncrementMonth: function onRequestIncrementMonth(currentDate) {
          var newDate = moment(currentDate).add(1, 'month');

          _this2.setState({
            displayedDate: newDate
          });

          _this2.props.loadPosts(_this2.props.organization.id, _this2.props.selectedTimezone, newDate.startOf('month').toDate(), newDate.endOf('month').toDate(), false);
        },
        previousSelectedDate: moment(this.state.dialogSelectedDate),
        selectedDate: this.state.dialogSelectedDate,
        minDate: moment().toDate(),
        maxDate: composeboxForm.maxDate ? moment(composeboxForm.maxDate).toDate() : undefined,
        onDateSelected: function onDateSelected(date) {
          _this2.setState({
            dialogSelectedDate: date
          });
        },
        eventsOnDay: function eventsOnDay(day) {
          return _this2.props.schedulePostMap["".concat(moment(day).startOf('day').valueOf())] || [];
        }
      })));
    }
  }]);

  return ScheduleArea;
}(Component)) || _class);
export { ScheduleArea as default };